import { Controller } from "@hotwired/stimulus";
import mapboxgl, { Marker } from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";

export default class extends Controller {
  static values = {
    center: Array,
    marker: Array,
    zoom: Number,
    bounds: Array,
    reverseGeocode: Boolean,
  };
  static targets = ["container", "field", "text"];

  connect() {
    mapboxgl.accessToken =
      "pk.eyJ1IjoibXJ3aWxsaWhvZyIsImEiOiJjbDI5YzRwZzkwMnNwM2NvNGY4aHh4eWR2In0.W4Eu3eTXf7XRC0e5K47zLw";

    this.initMap();
    this.initMarker();
    this.initGeocoder();

    document
      .querySelector('turbo-frame[id="modal"]')
      .addEventListener("turbo:frame-load", () => {
        this.map.resize();
      });
  }

  initMap() {
    const params = {
      container: this.containerTarget,
      style: "mapbox://styles/mapbox/outdoors-v11",
      center: this.centerValue,
      zoom: this.zoomValue,
      attributionControl: false,
      logoPosition: "bottom-right",
    };

    if (this.boundsValue.length > 0) {
      params.bounds = this.boundsValue;
    }

    const map = new mapboxgl.Map(params);

    map.addControl(new mapboxgl.NavigationControl(), "top-right");
    map.addControl(
      new mapboxgl.GeolocateControl({
        showUserLocation: false,
      }),
      "top-right"
    );

    map.on("click", ({ lngLat }) => {
      this.marker.setLngLat(lngLat).addTo(map);
      this.update(lngLat);
    });

    this.map = map;
  }

  initMarker() {
    const marker = new Marker({
      draggable: true,
    });

    marker.on("dragend", () => {
      this.update(marker.getLngLat());
    });

    if (this.hasMarkerValue && this.markerValue.length !== 0) {
      marker.setLngLat(this.markerValue).addTo(this.map);
    }

    this.marker = marker;
  }

  initGeocoder() {
    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      marker: false,
      flyTo: {
        speed: 1.8,
      },
      reverseGeocode: this.reverseGeocodeValue,
    });

    geocoder.on("result", (e) => {
      this.marker.setLngLat(e.result.center).addTo(this.map);
      this.update(e.result.center);
    });

    this.map.addControl(geocoder, "top-left");
    this.geocoder = geocoder;
    if (this.reverseGeocodeValue) {
      this.geocoder.on("results", (results) => {
        const feature = results.features[0];
        if (feature) {
          const locality = feature.context.find((contextObject) => {
            return (
              contextObject.id.startsWith("locality") ||
              contextObject.id.startsWith("place") ||
              contextObject.id.startsWith("district") ||
              contextObject.id.startsWith("region") ||
              contextObject.id.startsWith("country")
            );
          });

          this.textTarget.querySelector("input").value = locality.text;
        }
      });
    }
  }

  update() {
    this.map.flyTo({
      center: this.marker.getLngLat(),
      zoom: Math.max(this.map.getZoom(), 9),
    });
    this.fieldTarget.value = `POINT(${this.marker.getLngLat().lng} ${
      this.marker.getLngLat().lat
    })`;
    if (this.reverseGeocodeValue) {
      this.geocoder._geocode(
        `${this.marker.getLngLat().lat},${this.marker.getLngLat().lng}`
      );
    }
  }
}
